module.exports = {
      id: "check-usage",
      viewBox: "0 0 9 7",
      url: __webpack_public_path__ + "img/icons.91580017.svg#check-usage",
      toString: function () {
        return this.url;
      }
    }